var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ib-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "550px",
        "show-close": false,
        "empty-header": "",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "dialog-product-thank-you-wrapper d-flex align-items-center flex-column",
        },
        [
          _c("img", {
            staticClass: "payment-successful-img",
            attrs: {
              src: require("@/assets/img/illustrations/payment-successful.svg"),
              alt: "payment-successful",
            },
          }),
          _c("p", { staticClass: "title-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("paymentSuccessful")) + " "),
          ]),
          _c("p", { staticClass: "description" }, [
            _vm._v(" " + _vm._s(_vm.$t("infoTextAiRequests")) + " "),
          ]),
          _c(
            "div",
            [
              _c(
                "ib-button",
                {
                  attrs: { variant: "blue" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" OK ")]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }